import Footer, { FooterProps } from './Footer';
import withInteractor from './Footer.interactor';
import withPresenter from './Footer.presenter';

export type { FooterProps };
export default withInteractor(withPresenter(Footer));
